<template>
  <v-container fluid>
    <v-dialog v-model="orderfilterdialog" max-width="390">
    <Orderfilters v-on:hideOrderFilters="hideOrderFilters()" />
    </v-dialog>
    <v-dialog v-model="showPop" max-width="450">
    <Popup />
    </v-dialog>
    <v-dialog v-model="salesorderitemsdialog" max-width="450">
      <Orderitems   
        v-on:hideOrderItems="hideOrderItems()" 
      />
    </v-dialog>      
       
    <!-- mobile devices style -->
    <v-container v-if = "$vuetify.breakpoint.smAndDown">
      <v-row  class="d-flex" dense>
      <v-col cols="10">
        <v-select
          :items="salespersons"         
          item-value="SMAN_DOCNO"
          item-text="SMAN_DESC"
          label="Sales-persons"
          
          v-model="selectedsalesman"
          @change="getallsalesorders"
          clearable
        />
      </v-col>
      <v-col cols="2"  class="d-flex justify-center">
        <v-btn
          class="mt-2"
          fab
          icon
          small
          color="primary"
          @click="getallsalesorders"
        >
          <v-icon dark>
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-col>

        <v-col cols="8" class="d-flex align-center">
          <v-text-field     
            v-model="custsearch"
            clearable            
            label="Search in list"
            type="text"
            class="mt-2 Caption"
            condensed
          />
        </v-col>
        <v-col cols="2" class="d-flex justify-center">
          <!-- <v-btn color="primary" icon fab> -->
          <v-btn color="primary" @click="showOrderFilters" icon fab>
            <v-icon>
              mdi-filter
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="2" class="d-flex justify-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" icon fab>
                <v-icon>
                  mdi-sort
                </v-icon>
              </v-btn>
            </template> 
            <v-list v-for="custsortitem in custsort" :key="custsortitem.sortval">
              <v-list-item
                @click="sortCustomers(custsortitem.sortby, custsortitem.sortord)"
              >
                {{ custsortitem.sortdesc }}
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <!-- <v-dialog v-model="custstmtdialog" max-width="550">
        <Customerstatement v-on:hideCustStmt="hideCustStmt()" />
      </v-dialog>       -->
    <div class="mt-4" v-for="salesorder in matches" :key="salesorder.SAL_DOCNO">
        <Ordercard
        :so_no="salesorder.SAL_DOCNO"
        :date="salesorder.SAL_DOCDATE"
        :partycode="salesorder.SAL_SUBLEDGER_DOCNO"
        :partyname="salesorder.PARTYMST_DESC"
        :netamt="salesorder.SAL_NET_AMOUNT"
        :createdby="salesorder.SAL_CREATED_BY"       
        :status="salesorder.SAL_DOCUMENT_STATUS_DOCNO"
        :salsubledger_docno="salesorder.SAL_SUBLEDGER_DOCNO"
        :EDD="salesorder.SAL_DELIVERY_DATE"
        v-on:showOrderItems="showSalesOrderItems(salesorder)"
      /> 
      </div> 
    </v-container>   
    <v-data-table
      v-if = '$vuetify.breakpoint.smAndUp'
      :headers="salesordersHeaders"
      :items="allsalesorders"  
      :search="search"  
      class="elevation-1"     
    >
      <template v-slot:top>
        <v-toolbar flat> 
          <v-text-field         
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details          
          ></v-text-field>
          <v-divider
            inset
            vertical
            class="ml-5 mr-5"
          ></v-divider>
          <v-select
          :items="salespersons"         
          item-value="SMAN_DOCNO"
          item-text="SMAN_DESC"
          label="Sales-persons"
          v-model="selectedsalesman"
          @change="getallsalesorders"
         
          hide-details   
          clearable
        />
        <v-divider
          inset
          vertical
          class="ml-5 mr-5"
        ></v-divider>
        <v-btn
          class="mt-1"
          fab
          icon
          small
          color="primary"
          @click="getallsalesorders"
        >
          <v-icon dark>
            mdi-refresh
          </v-icon>
        </v-btn>

          <v-dialog
            v-model="dialog"
            max-width="950px"
          >
          <v-card>
            <v-card-title>
              <span class="text-h6">{{ itemsTitle }}</span>               
            </v-card-title>
            <v-card-text>
              <v-container>             
                <v-data-table
                  :headers="salesorderitemsHeaders"
                  :items="salesorderitems"
                  class="elevation-1"     
                >
                <template v-slot:item.total="{ item }">
                  {{`${item.SALDET_QTY  * item.SALDET_RATE}`}}                   
                </template>
                </v-data-table>   
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer>
                  <span class="text-h6 sm-12">Net Amount: {{ netAmount }} AED</span>
                  <span class="font-italic">  (including VAT)</span>
                  <v-spacer>
                  <span class=" sm-12 font-weight-thin">Date & Time  :{{ itemDate }}</span>
                  </v-spacer>
              </v-spacer>              
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Back
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogUpdateETD"
            max-width="950px"
          >
           <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              @click="getAllCustomers"
            >
              New Quotation
            </v-btn>
          </template> -->
          <!-- {{customers[1]}} -->
          <!-- {{salespersons}} -->
          <v-card>
            <v-card-title>
              <!-- <span class="text-h5">{{ formTitle }}</span> -->
            </v-card-title>
            <!-- <template v-slot:prepend-item>
            <v-list-item>
              <v-list-item-content>
                <v-text-field v-model="custsearch" placeholder="Search" @input="searchCustomers" append-icon="mdi-search"></v-text-field>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template> -->

          <v-container fluid>
            <!-- <v-select
          :options="customers"
          :value="person.country"
          @input="(country) => updateCountry(person, country)"
          /> -->
            <!-- <v-select v-model="selectedCustomer" 
                      :items="allcustomers"  
                      item-value="PARTYMST_DOCNO"
                      item-text="PARTYMST_DESC"
                      label="Customer Name" 
                      solo>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-text-field v-model="custsearch" placeholder="Search for Customers" @input="searchCustomers" append-icon="mdi-search"></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select> -->
          </v-container>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="3"
                    md="2"
                  >
                    <v-text-field
                      v-model="editedItem.SAL_SUBLEDGER_DOCNO"
                      label="Customer Code"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="8"
                  >
                    <v-text-field
                      v-model="editedItem.PARTYMST_DESC"
                      label="Customer Name"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="2"
                  >
                    <v-text-field
                      v-model="editedItem.SAL_DOCNO"
                      label="SO-NO"
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="8"
                    md="6"
                  >
                    <v-text-field
                      v-model="editedItem.SAL_DELIVERY_REMARKS"
                      label="ORDER REMARKS"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                  >
                    <v-text-field
                      v-model="editedItem.SAL_DOCUMENT_STATUS"
                      label="Status"
                    ></v-text-field>
                  </v-col>
                   
                    
                    <v-col
                      cols="12"
                      sm="8"
                      md="3"
                    >
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="editedItem.SAL_DELIVERY_DATE"
                        persistent
                        width="290px"                        
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.SAL_DELIVERY_DATE"
                            label="ETD"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedItem.SAL_DELIVERY_DATE"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="modal = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog.save(editedItem.SAL_DELIVERY_DATE)"
                          >
                            OK
                          </v-btn>                        
                        </v-date-picker>
                      </v-dialog>
                    </v-col>   
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeUpdateETD"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="saveETD"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
          <!-- <v-switch
            v-model="singleExpand"
            label="Single expand"
            class="mt-2"
          ></v-switch> -->
        </v-toolbar> 
      </template>
    <!-- <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        Order details {{ item.SAL_DOCNO }}
      </td>      
    </template> -->
      <template v-slot:item.date="{ item }">
        {{date(item)}}     
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="viewItem(item)"
        >
          mdi-eye 
        </v-icon>  
        <v-icon v-if="editETD"
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>  
      </template>
    <!-- <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="getallsalesorders"
      >
        Refresh
      </v-btn>
    </template> -->
  </v-data-table> 

  </v-container>  
</template>

<script>   
import moment from "moment";
import Ordercard from '../components/Ordercard.vue';
import Orderitems from "@/components/Orderitems";
import Orderfilters from "@/components/Orderfilters";
import Popup from "@/components/Popup";
import secure_axios from "../services/secure_axios";


export default {
  components: {
    Ordercard,
    Orderitems,
    Popup,
    Orderfilters
  },

  data() {
    return {
      pagination: {
        sortBy: 'name'
      },
      selected: [], 
      showPop:"",   
      selectedsalesman:"", 
      search: "",
      custsearch: null,   
      expanded:[],
      expandeditem:[],
      orderfilterdialog: false,
      viewItems:[],
      itemsTitle:"", 
      netAmount:"",
      itemDate:"",     
      sodoctype: 'SO',
      salesorderitemsdialog: false,      
      dialog: false,
      dialogUpdateETD: false,
      modal: false,
      dialogDelete: false,
      today: new Date().toISOString().substr(0, 10),
      salesordersHeaders: [
        { text: 'SO#',align: 'start',value: 'SAL_DOCNO',sortable: false, width: '5%'},
        { text: 'Date', value: 'date',width: '5%'},
        { text: 'Party Code (g)', value: 'SAL_SUBLEDGER_DOCNO',width: '5%' },
        { text: 'Party Name', value: 'PARTYMST_DESC',width: '30%'  },      
        { text: 'Net Amt (AED)', value: 'SAL_NET_AMOUNT',width: '5%' },     
        { text: 'Created by', value: 'SAL_CREATED_BY',sortable: false,width: '5%'  },
        { text: 'Status', value: 'SAL_DOCUMENT_STATUS',width: '10%' },
        { text: 'ETD', value: 'SAL_DELIVERY_DATE',width: '10%' },           
        { text: 'More', value: 'actions', sortable: false,align: 'end',width: '5%' },
      ],  
      salesorderitemsHeaders: [
        { text: 'SM',align: 'start',value: 'SALDET_DOCSRNO',sortable: false},
        { text: 'Code', value: 'SALDET_STOCK_DOCNO'},
        { text: 'Description', value: 'SALDET_STOCK_DESC' },
        { text: 'Unit', value: 'SALDET_UNIT_DOCNO' },      
        { text: 'Qty', value: 'SALDET_QTY' },     
        { text: 'Unitprice', value: 'SALDET_RATE',sortable: false  },
        { text: 'Amount', value:'total' },       
      ],   
      editedIndex: -1,
      editedItem: {},
      defaultItem: {}, 
      custsort: [
        {
          sortval: 0,
          sortdesc: "Pennding",
          sortby: "AVG_SALE",
          sortord: -1,
        },
        {
          sortval: 1,
          sortdesc: "Active",
          sortby: "AVG_SALE",
          sortord: 1,
        },
        {
          sortval: 2,
          sortdesc: "Completed",
          sortby: "CUSTOUTS_OUTSTANDING",
          sortord: -1,
        },
        {
          sortval: 3,
          sortdesc: "WIP",
          sortby: "CUSTOUTS_OUTSTANDING",
          sortord: 1,
        },
        {
          sortval: 4,
          sortdesc: "Partial",
          sortby: "FIRST_INVOICE_DATE",
          sortord: 1,
        },
        {
          sortval: 5,
          sortdesc: "ALL",
          sortby: "LAST_INVOICE_DATE",
          sortord: -1,
        },
      ],              
    };
  },
  computed: {
    usersperson() {
      var smanno =this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO;
      if (smanno) {
        return smanno;
      } else {
        return "";
      }
    },
    person(){
      if (this.usersperson != "")
      return this.salesperson
      else
      return ""
    },
    sessionAPI() {
      return this.$store.getters.sessionAPI;
    },  
    salespersons() {
      return this.$store.getters.salespersons;
    },
    salesperson() {
      return this.$store.getters.salesperson;
    },
    sman() {
      if (this.selectedsalesman) {
        return this.selectedsalesman;
      } else {
        return this.usersperson;
      }
    },
    allsalesorders(){      
      return this.$store.getters.allsalesorders;
    },
    salesorderitems(){      
      return this.$store.getters.salesorderitems;      
    },     
    itemDisplay(){
      if (this.salesorderitems.length() > 0){
        return true
      }else{
        return false
      }
    },
    isAdmin(){
      if(this.$store.getters.fbuserdata.usertype == 1)
       return true;
      else
       return false;
    },
    edit_premissions(){
      if (typeof(this.$store.getters.fbuserdata.edit_premissions) != 'undefined' && this.$store.getters.fbuserdata.edit_premissions != null)
        return this.$store.getters.fbuserdata.edit_premissions.includes("etd")
      else  
        return false
    },
    editETD(){
      if(this.edit_premissions || this.isAdmin)
        return true;
      else
        return false;
    },
    matches() {
      if (this.custsearch == null) {
        return this.allsalesorders;
      } else {
        return this.allsalesorders.filter((salesorder) =>
          salesorder.PARTYMST_DESC.toLowerCase().includes(
            this.custsearch.toLowerCase()
          )
        );
      }
    },
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogUpdateETD (val) {
      val || this.closeUpdateETD()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  }, 
  methods: {
    setSalesPerson() {
      this.$store.dispatch("getSalesPerson", { smandocno: this.sman });
    },
    getallsalesorders() {
      this.setSalesPerson();
      this.$store.dispatch("getallsalesorders", { smandocno: this.salesperson,sodoctype:this.sodoctype });
    }, 
    getsalesorderitems(itemkey) {
      this.$store.dispatch("getsalesorderitems",{ saldet_docno:itemkey }) 
    },
    showSalesOrderItems(salesorder) {      
      this.$store.dispatch("selectedorder", salesorder);
      this.$store.dispatch("clearorderitems");      
      this.$store.dispatch("getsalesorderitems", {
        saldet_docno: salesorder.SAL_DOCNO,       
      });
      this.salesorderitemsdialog = true;
    },
    clickRow(item, event) {
      if(event.isExpanded) {
        const index = this.expanded.findIndex(i => i === item);
        this.expanded.splice(index, 1)
      } else {
        this.expanded.push(item);
      }
    },
    date(item){
      return(moment(item.SAL_DOCDATE).format('DD-MM-YYYY'))
    },
    // filterOnlyCapsText (value,  ) {
    //     return value != null &&
    //       search != null &&
    //       typeof value === 'string' &&
    //       value.toString().toLocaleUpperCase().indexOf(search) !== -1
    //   }, 
    toDate(date){
      return new Date(date - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10)
    },
    viewItem(item){
      console.log(item.SAL_DOCNO)
      this.itemsTitle = item.SAL_DOCNO+" - "+item.PARTYMST_DESC
      this.$store.dispatch("getsalesorderitems",{ saldet_docno:item.SAL_DOCNO,saldet_doctype:item.SAL_DOCTYPE }) 
      this.netAmount = item.SAL_NET_AMOUNT
      this.itemDate = item.SAL_DOCDATE
      this.dialog = true
    },
    editItem (item) {
      console.log(item.SAL_DOCNO)
      this.dialogUpdateETD = true
      this.editedIndex = this.allsalesorders.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    closeUpdateETD(){
      this.dialogUpdateETD = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    changeSort(column) {
      console.log(column);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    sortCustomers(sortby, sortord) {
      return this.allsalesorders.sort(function(a, b) {
        return a[sortby] > b[sortby] ? sortord : -1 * sortord;
      });
    },
    showOrderFilters() {
      this.orderfilterdialog = true;
    },
    hideOrderFilters() {
      this.orderfilterdialog = false;
    },
    // close () {
    //     this.dialog = false
    //     this.$nextTick(() => {
    //       this.editedItem = Object.assign({}, this.defaultItem)
    //       this.editedIndex = -1
    //     })
    //   },
    //   closeDelete () {
    //     this.dialogDelete = false
    //     this.$nextTick(() => {
    //       this.editedItem = Object.assign({}, this.defaultItem)
    //       this.editedIndex = -1
    //     })
    //   },
    // saveETD() {
    //   if (this.editedIndex > -1) {
    //     Object.assign(this.editedItem[this.editedIndex], this.editedItem)
    //   } else {
    //     this.editedItem.push(this.editedItem)
    //   }
    //   this.close()
    // },
    saveETD(){
      if(this.editedIndex > -1 && this.editedItem.SAL_DELIVERY_DATE > this.today ) {
        const sendPostRequest = async () => {
        this.$store.dispatch("getLoading", true);
        try {
          const updateETD = await secure_axios.put(this.sessionAPI + "orders", {
              SAL_DOCNO : this.editedItem.SAL_DOCNO,
              SAL_DOCTYPE : this.editedItem.SAL_DOCTYPE,
              SAL_DELIVERY_DATE : this.dateReverse(this.editedItem.SAL_DELIVERY_DATE),
              SAL_DOCUMENT_STATUS_DOCNO: this.editedItem.SAL_DOCUMENT_STATUS_DOCNO,
              SAL_DOCUMENT_STATUS_REMARKS:this.editedItem.SAL_DOCUMENT_STATUS_REMARKS,
          });
          let updateddate = updateETD.data.orderUpdate[2].trim(20)
          // console.log(updateddate.orderUpdate[2])
          if (updateETD.status == 200){
            alert(`ETD for order ${this.editedItem.SAL_DOCTYPE } ${ this.editedItem.SAL_DOCNO} update succesfully to ${this.formatDate(updateddate)}`);
            this.dialogUpdateETD = false
          }
        } catch (err) {
          // Handle Error Here
          console.error(err);
          this.$store.dispatch("getError", err);
        }       
        this.$store.dispatch("getLoading", false);
      };
      sendPostRequest()
      }
    },
    isMobile() {
      if( screen.width <= 760 ) {
        return true;
      }
      else {
        return false;
      }
    },
    hideOrderItems() {
      this.salesorderitemsdialog = false;
    },
    dateReverse(input) {
      var array = (input || '').toString().split(/-/g);
      array.push(array.shift());
      return array.join('-') || null;
    }, 
    formatDate(date){
      return moment(date).format('DD-MMMM-YYYY ddd').toString()
    }, 
  }, 
  mounted() {
    this.$store.dispatch("getLoading", true);
    this.setSalesPerson(this.usersperson);
    this.getallsalesorders();
    this.$store.dispatch("getLoading", false);
  },  
}        
</script>
<style scoped>
</style>